import clsx from 'clsx';
import React from 'react';

import ModalPopup from '@/src/components/common/Elements/Modal/ModalPopup/ModalPopup';

const UndoRecordModal = ({ onClose, onConfirm }) => {
  return (
    <ModalPopup
      title={'Undo Action?'}
      id={'undo-record-modal'}
      modalWidth={clsx('tw-w-[628px]')}
      message={'Unmarking the entry as recorded will re-open the entry. Do you wish to proceed?'}
      onClose={onClose}
      onConfirm={onConfirm}
    />
  );
};

export default UndoRecordModal;
